import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { getControlSheet } from "../../redux/actions/controlSheet.action";
import { getDefaultCompany } from "../../redux/actions/defaultCompany";
import { getAllCompany } from "../../redux/actions/companyAccess";
import PageHeader from "../../components/PageHeader/PageHeader";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  createCCPaymentLink,
  sendCCPaymentEmail,
  sendEmail,
  sendOrderConfirmationAutoApprovedPTEmail,
  sendOrderConfirmationEmail,
} from "../../redux/actions/email.action";
import { TabTitle } from "../../utils/GeneralFunction";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import notification from "../../utils/notification";
import { ReadCookie } from "../../utils/readCookie";
import { MailOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Input, Select, Table, Modal } from "antd";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import numeral from "numeral";
import moment from "moment";
import "./pickticket.css";
import { getRegion } from "../../redux/actions/region.action";
import { getGender } from "../../redux/actions/gender.action";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { loadSalePerson } from "../../redux/actions/salePerson/salePersonForm.action";
import { getSaleOrderFormData } from "../../redux/actions/salesOrder.action";
import { getCCOrdersCharge } from "../../redux/actions/ccOrdersCharge.action";
import Loader from "react-loader-spinner";
import { DollarOutlined } from "@ant-design/icons";

const { Option } = Select;
const CCOrdersCharge = () => {
  TabTitle("CC Orders Charge");
  const [form] = Form.useForm();
  const [minimize, setMinimize] = useState(false);
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  const dispatch = useDispatch();
  const [selectedRows, setSelectedRows] = useState([]);
  const [controlSheet, setControlSheet] = useState([]);
  const [spinner, setSpinner] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState([]);
  const tableRef = useRef(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { gender, region, salePersonForm, paymentterm } = useSelector(
    (state) => state
  );
  const [isChargeModalVisible, setIsChargeModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [chargeAmount, setChargeAmount] = useState("");
  console.log(selectedRecord, "selectedRecord");

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRows(selectedRows);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  useEffect(() => {
    dispatch(getAllCompany(token));
    dispatch(getDefaultCompany(token));
    dispatch(getRegion(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getPaymentTerm(token, menuId));
    dispatch(loadSalePerson(token));
    // dispatch(getControlSheet(token)).then((res) => {
    //     setLoading(false);
    //     setSpinner(false);
    //     setControlSheet(res?.payload?.data);
    // });
  }, [dispatch, menuId, token]);

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 50,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "PT #",
      dataIndex: "ship_header_no",
      key: "ship_header_no",
      width: 70,
      render: (text, record) => (
        <Link
          style={{ color: "#0d6efd", textDecoration: "underline" }}
          to={
            "/order-shipment?mode=edit&order_id=" +
            record.ship_header_id +
            "&customer_id/" +
            record.customer_id +
            "?edit=yes"
          }
        >
          {text}
        </Link>
      ),
    },
    {
      title: "PT Date",
      render: (text, record) => {
        return <>{moment(record.ship_date).format("MM-DD-YYYY")}</>;
      },
      width: 90,
    },
    {
      title: "Start Date",
      render: (text, record) => {
        return <>{moment(record.start_date).format("MM-DD-YYYY")}</>;
      },
      width: 90,
    },
    {
      title: "Cancel Date",
      render: (text, record) => {
        return <>{moment(record.cancel_date).format("MM-DD-YYYY")}</>;
      },
      width: 90,
    },
    {
      title: "Customer",
      dataIndex: "addressee",
      key: "addressee",
      width: 200,
    },
    {
      title: "SO #",
      dataIndex: "order_header_no",
      key: "order_header_no",
      width: 80,
    },
    {
      title: "PO #",
      dataIndex: "reference_no",
      key: "reference_no",
      width: 120,
    },
    {
      title: "Qty",
      render: (text, record) => {
        return <>{parseFloat(record.quantity).toFixed(0)}</>;
      },
      width: 60,
      align: "right",
    },
    {
      title: "Amount",
      render: (text, record) => {
        return <>$ {numeral(record.gross_amount).format("0,00")}</>;
      },
      width: 80,
      align: "right",
    },
    {
      title: "Discount Amount",
      render: (text, record) => {
        return <>$ {numeral(record.discount_amount).format("0,00")}</>;
      },
      width: 120,
      align: "right",
    },
    {
      title: "Freight",
      render: (text, record) => {
        return <>$ {numeral(record.shipping_cost).format("0,00")}</>;
      },
      width: 80,
      align: "right",
    },
    {
      title: "Surcharge Amount",
      render: (text, record) => {
        return <>$ {numeral(record.surcharge_amount).format("0,00")}</>;
      },
      width: 120,
      align: "right",
    },
    {
      title: "Net Amount",
      render: (text, record) => {
        return <>$ {numeral(record.net_amount).format("0,00")}</>;
      },
      width: 100,
      align: "right",
    },
    {
      title: "Term",
      dataIndex: "term_name",
      key: "term_name",
      width: 100,
    },
    {
      title: "Sale Person",
      dataIndex: "salesperson_name",
      key: "salesperson_name",
      width: 200,
    },
    {
      title: "Region",
      dataIndex: "region_name",
      key: "region_name",
      width: 200,
    },
    {
      title: "PT Status",
      dataIndex: "pt_status_name",
      key: "pt_status_name",
      width: 160,
    },
    {
      title: "Approved",
      dataIndex: "is_approved",
      key: "is_approved",
      render: (text, record) => {
        return <>{record.is_approved ? "Yes" : "No"}</>;
      },
      width: 80,
    },
    {
      title: "Customer Email",
      dataIndex: "customer_email_address",
      key: "customer_email_address",
      width: 200,
    },
    {
      title: "Customer Phone",
      dataIndex: "customer_phone_no",
      key: "customer_phone_no",
      width: 120,
    },
    {
      title: "Comment",
      dataIndex: "cs_comment",
      key: "cs_comment",
      width: 220,
    },
    {
      title: "Expiration Duration",
      dataIndex: "cc_session_date",
      key: "cc_session_date",
      width: 220,
      render: (text, record, index) => {
        console.log(new Date(record.cc_session_date).toString());


        if (!text) {
          return "";
        }
        const dbTime = moment(text).add(5, "hours");
        const diff = moment().diff(dbTime, "minutes");

        console.log("Now :", moment().format("YYYY-MM-DD HH:mm:ss"));
        console.log("DB+5:", dbTime.format("YYYY-MM-DD HH:mm:ss"));
        console.log("Diff:", diff);

        return record.cc_payment_status === "PENDING" && diff < 15
          ? 15 - diff
          : "";
        // return record.cc_payment_status === "PENDING" && diff < 15
        //   ? 15 - moment.utc().diff(moment.utc(text), "minutes") + " min"
        //   : "";
      },
    },
    {
      title: "Checkout Status",
      dataIndex: "cc_payment_status",
      key: "cc_payment_status",
      width: 220,
      render: (text, record, index) => {
        if (!text) {
          return "";
        }
        const sessionTime = moment(record.cc_session_date).add(5, "hours");
        const diff = moment().diff(sessionTime, "minutes");

        return text === "PENDING" && diff > 14 ? "" : text;
      },
    },

    {
      title: "# of Emails Sent",
      dataIndex: "pt_count",
      key: "pt_count",
      render: (text, record, index) => {
        return text ? text : 0;
      },
    },
    // {
    //   title: "Charge",
    //   render: (text, record, index) => (
    //     <Button
    //       icon={<DollarOutlined />}
    //       onClick={() => openChargeModal(record)}
    //     >
    //       Charge
    //     </Button>
    //   ),
    //   width: 140,
    // },
    {
      title: "Send Email",
      render: (text, record, index) => {
        return (
          <Button
            icon={<MailOutlined />}
            loading={loadings[index]}
            onClick={() => sendingEmail(record, index)}
          >
            Send Email
          </Button>
        );
      },
      width: 140,
    },
  ];

  const sendToAll = () => {
    setSpinner(true);
    selectedRows?.map((res) => {
      if (res.email) {
        if (res?.is_approved) {
          // Approved
          dispatch(sendOrderConfirmationAutoApprovedPTEmail(token, res)).then(
            (res) => {
              if (res.type === "SEND_EMAIL_SUCCESS") {
                setSelectedRowKeys([]);
                setSelectedRows([]);
                setSpinner(false);
                notification("success", res?.payload);
              }
            }
          );
        } else {
          dispatch(sendOrderConfirmationEmail(token, res)).then((res) => {
            if (res.type === "SEND_EMAIL_SUCCESS") {
              setSelectedRowKeys([]);
              setSelectedRows([]);
              setSpinner(false);
              notification("success", res?.payload);
            }
          });
          // Not Approved
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Customer Email is required!",
        });
      }
    });
  };

  function sendingEmail(e, index) {
    setLoading(true);
    const data = {
      ship_date: e.ship_date,
      cancel_date: e.cancel_date,
      addressee: e.addressee,
      order_header_no: e.order_header_no,
      reference_no: e.reference_no,
      quantity: e.quantity,
      gross_amount: e.gross_amount,
      net_amount: e.net_amount,
      surcharge_amount: e.surcharge_amount,
      term_name: e.term_name,
      salesperson_name: e.salesperson_name,
      salesperson_email: e.salesperson_email,
      region_name: e.region_name,
      pt_status_name: e.pt_status_name,
      is_approved: e.is_approved,
      phone: e.customer_phone_no,
      is_email: true,
      is_approved: e.is_approved ? true : false,
      customer_id: e.customer_id,
      email: e.customer_email_address,
      cs_comment: e.cs_comment,
      ship_header_id: e.ship_header_id,
      ship_header_no: e.ship_header_no,
      shipping_cost: e.shipping_cost,
      secondary_email: e.secondary_email,
    };
    dispatch(createCCPaymentLink(token, e)).then((res) => {

      if (res.type === "SEND_EMAIL_SUCCESS") {
        let payment_link = res.payload.paymentLink;
        dispatch(sendCCPaymentEmail(token, { ...data, payment_link })).then((result) => {
          if (result.type === "SEND_EMAIL_SUCCESS") {
            Swal.fire({
              icon: "success",
              title: "",
              text: result.payload
            });
            setLoading(false);
          }
        })
        setLoading(false);
      } else if (res.type === "SEND_EMAIL_ERROR") {
        if (res.payload.status == 500) {
          Swal.fire({
            icon: "error",
            title: "",
            text: res.payload.data.message || "Error Occurred.",
          });
          setLoading(false);
        } else {
          Swal.fire({
            icon: "error",
            title: "",
            text: res.payload.data.message,
          });
          setLoading(false);
        }
      }
      dispatch(getCCOrdersCharge(token, form.getFieldValue())).then((res) => {
        // setLoading(false);
        setControlSheet(res?.payload?.data);
      });
    });
    // setLoadings((prevLoadings) => {
    //     const newLoadings = [...prevLoadings];
    //     newLoadings[index] = true;
    //     return newLoadings;
    // });

    // const data = {
    //     ship_date: e.ship_date,
    //     cancel_date: e.cancel_date,
    //     addressee: e.addressee,
    //     order_header_no: e.order_header_no,
    //     reference_no: e.reference_no,
    //     quantity: e.quantity,
    //     gross_amount: e.gross_amount,
    //     net_amount: e.net_amount,
    //     surcharge_amount: e.surcharge_amount,
    //     term_name: e.term_name,
    //     salesperson_name: e.salesperson_name,
    //     salesperson_email: e.salesperson_email,
    //     region_name: e.region_name,
    //     pt_status_name: e.pt_status_name,
    //     is_approved: e.is_approved,
    //     phone: e.phone,
    //     is_email: true,
    //     customer_id: e.customer_id,
    //     email: e.email,
    //     cs_comment: e.cs_comment,
    //     ship_header_id: e.ship_header_id,
    //     ship_header_no: e.ship_header_no,
    //     shipping_cost: e.shipping_cost,
    //     secondary_email: e.secondary_email,
    // }
    // if (e.email) {
    //     if (e?.is_approved) {
    //         // Approved
    // dispatch(sendOrderConfirmationAutoApprovedPTEmail(token, data)).then((res) => {
    //     if (res.type === "SEND_EMAIL_SUCCESS") {
    //         setLoadings((prevLoadings) => {
    //             const newLoadings = [...prevLoadings];
    //             newLoadings[index] = false;
    //             return newLoadings;
    //         });
    //         notification("success", res?.payload);
    //     }
    // });
    //     } else {
    // dispatch(sendOrderConfirmationEmail(token, data)).then((res) => {
    //     if (res.type === "SEND_EMAIL_SUCCESS") {
    //         setLoadings((prevLoadings) => {
    //             const newLoadings = [...prevLoadings];
    //             newLoadings[index] = false;
    //             return newLoadings;
    //         });
    //         notification("success", res?.payload);
    //     }
    // });
    //         // Not Approved
    //     }

    // }
    // else {
    //     Swal.fire({
    //         icon: "error",
    //         title: "Oops...",
    //         text: "Customer Email is required!"
    //     });
    //     setLoadings((prevLoadings) => {
    //         const newLoadings = [...prevLoadings];
    //         newLoadings[index] = false;
    //         return newLoadings;
    //     });
    // }
  }

  const openChargeModal = (record) => {
    setSelectedRecord(record); // record jiska charge set karna hai
    setChargeAmount(record.net_amount || ""); // default value optional
    setIsChargeModalVisible(true);
  };

  const handleChargeOk = async () => {
    if (!selectedRecord) return;

    // Optional: validate chargeAmount
    if (!chargeAmount || parseFloat(chargeAmount) <= 0) {
      Swal.fire({
        icon: "error",
        title: "Invalid Amount",
        text: "Please enter a valid charge amount.",
      });
      return;
    }

    try {
      setLoading(true); // optional spinner

      // Call backend to create payment link
      const res = await dispatch(
        createCCPaymentLink(token, {
          ...selectedRecord,
          net_amount: chargeAmount, // override with modal input
        })
      );

      if (res.type === "SEND_EMAIL_SUCCESS") {
        const payment_link = res.payload.paymentLink;

        if (payment_link) {
          // Open payment link in new window / popup
          const width = 800; // width of popup
          const height = 900; // height of popup

          // Calculate center position
          const left = window.screenX + (window.outerWidth - width) / 2;
          const top = window.screenY + (window.outerHeight - height) / 2;

          window.open(
            payment_link,
            "_blank",
            `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
          );
        }
      } else if (res.type === "SEND_EMAIL_ERROR") {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            res.payload?.data?.message ||
            "Error occurred while creating payment link.",
        });
      }

      // Optional: refresh table after creating payment link
      dispatch(getCCOrdersCharge(token, form.getFieldValue())).then((res) => {
        setControlSheet(res?.payload?.data);
      });
    } catch (error) {
      console.error("❌ Error creating payment link:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while creating payment link.",
      });
    } finally {
      setLoading(false);
      setIsChargeModalVisible(false);
      setSelectedRecord(null);
      setChargeAmount("");
    }
  };

  const handleChargeCancel = () => {
    setIsChargeModalVisible(false);
    setSelectedRecord(null);
    setChargeAmount("");
  };
  const onFinish = async () => {
    setSpinner(true);
    await form
      .validateFields()
      .then((values) => {
        dispatch(getCCOrdersCharge(token, values)).then((res) => {
          setSpinner(false);
          console.log("res?.payload?.data", res?.payload?.data)
          setControlSheet(res?.payload?.data);
        });
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"CC Orders Charge"}
          minimize={setMinimize}
          check={minimize}
        />
        {/* Loader */}
        {loading && (
          <div className="loaderDiv">
            <Loader type="Grid" color="#212121" height={40} width={40} />
          </div>
        )}
        {!minimize && (
          <div className="bodyStyle">
            <div className="formProduct p-0">
              <Form onFinish={onFinish} form={form} name="control-hooks">
                <div className="container-fluid pbpx-5 ptpx-5">
                  <Brow>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div>
                          <Form.Item
                            name="ship_no"
                            label="PT #"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            rules={[
                              {
                                pattern: new RegExp(
                                  /^(?!0*[.,]0*$|[.,]0*$|0*$)\d+[,.]?\d{0,6}$/
                                ),
                                message: "Must Be a Number.",
                              },
                            ]}
                          >
                            <Input size="small" className="styleInput" />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div>
                          <Form.Item
                            name="order_no"
                            label="Order #"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input size="small" className="styleInput" />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div className="relative">
                          <Form.Item
                            name="from_date"
                            label="From Date:"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={moment().startOf("year")}
                          >
                            <DatePicker
                              size="small"
                              className="styleInput w-100"
                              format={"MM-DD-YYYY"}
                              defaultValue={moment().startOf("year")}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div>
                        <div className="relative">
                          <Form.Item
                            name="to_date"
                            label="To Date:"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={moment().endOf("year")}
                          >
                            <DatePicker
                              size="small"
                              className="styleInput w-100"
                              format={"MM-DD-YYYY"}
                              defaultValue={moment().endOf("year")}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div>
                          <Form.Item
                            name="customer"
                            label="Customer"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input size="small" className="styleInput" />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div>
                          <Form.Item
                            name="po_no"
                            label="PO #"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input size="small" className="styleInput" />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="slc">
                        <Form.Item
                          name="sale_person"
                          label="Sale Person"
                          labelAlign="left"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue={"All"}
                        >
                          <Select
                            size="small"
                            showSearch
                            optionFilterProp="children"
                            filterSort={(optionA, optionB) =>
                              optionB?.value !== null
                                ? optionA.children
                                  .toLowerCase()
                                  .localeCompare(
                                    optionB.children.toLowerCase()
                                  )
                                : ""
                            }
                            className="styleInput w-100"
                            defaultValue={form.getFieldValue().sale_person}
                          >
                            <Option value={null}>All</Option>
                            {salePersonForm?.payload?.data.map((val, index) => {
                              return (
                                <Option key={index} value={val.sales_person_id}>
                                  {val.salesperson_name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="slc">
                        <Form.Item
                          name="region"
                          label="Region"
                          labelAlign="left"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue={"All"}
                        >
                          <Select
                            size="small"
                            showSearch
                            optionFilterProp="children"
                            filterSort={(optionA, optionB) =>
                              optionB?.value !== null
                                ? optionA.children
                                  .toLowerCase()
                                  .localeCompare(
                                    optionB.children.toLowerCase()
                                  )
                                : ""
                            }
                            className="styleInput w-100"
                          >
                            <Option value={null}>All</Option>
                            {region?.payload?.data.map((val) => {
                              return (
                                <Option
                                  key={val.region_id}
                                  value={val.region_id}
                                >
                                  {val.region_name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="slc">
                        <Form.Item
                          name="gender"
                          label="Gender"
                          labelAlign="left"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue={"All"}
                        >
                          <Select
                            size="small"
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, options) =>
                              options.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            className="styleInput w-100"
                          >
                            <Option value={null}>All</Option>
                            {gender?.payload?.data.map((val) => {
                              return (
                                <Option
                                  key={val.gender_id}
                                  value={val.gender_id}
                                >
                                  {val.gender_name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="slc">
                        <Form.Item
                          name="terms"
                          label="Terms"
                          labelAlign="left"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue={"All"}
                        >
                          <Select
                            size="small"
                            showSearch
                            optionFilterProp="children"
                            filterSort={(optionA, optionB) =>
                              optionB?.value !== null
                                ? optionA.children
                                  .toLowerCase()
                                  .localeCompare(
                                    optionB.children.toLowerCase()
                                  )
                                : ""
                            }
                            className="styleInput w-100"
                            defaultValue={form.getFieldValue().terms}
                          >
                            <Option value={null}>All</Option>
                            {paymentterm?.payload?.data.map((val) => {
                              return (
                                <Option value={val.term_id}>
                                  {val.term_name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div>
                          <Form.Item
                            name="is_approved"
                            label="Is Approved"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={"All"}
                          >
                            <Select size="small" tabIndex={26}>
                              <Option key={3} value={null}>
                                All
                              </Option>
                              <Option key={1} value={"True"}>
                                Yes
                              </Option>
                              <Option key={2} value={"False"}>
                                NO
                              </Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div>
                          <Form.Item
                            name="email"
                            label="Email"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input size="small" className="styleInput" />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div>
                          <Form.Item
                            name="phone"
                            label="Phone"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input size="small" className="styleInput" />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                  </Brow>
                </div>
              </Form>
              <Button
                htmlType="submit"
                type="primary"
                className="submit-btn-btm "
                onClick={onFinish}
              >
                Submit
              </Button>
            </div>
          </div>
        )}
      </div>
      <div style={{ marginTop: 10 }}>
        <Table
          title={() => (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <DownloadTableExcel
                filename={`Control-Sheet-${moment().format("MM-DD-YYYY")}`}
                sheet="Control Sheet"
                currentTableRef={tableRef.current}
              >
                <span className="print_icon printing_class">
                  <input
                    style={{ height: "30px", width: "30px" }}
                    size={"large"}
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                  />
                </span>
              </DownloadTableExcel>
              {selectedRows.length ? (
                <Button onClick={() => sendToAll()}>
                  Selected {selectedRows.length} Items
                </Button>
              ) : (
                ""
              )}
            </div>
          )}
          rowSelection={{ ...rowSelection }}
          rowKey={(record, index) => `${record.ship_header_no}_${record.ship_header_id}_${index}`}
          ref={tableRef}
          size="small"
          scroll={{ x: 3600 }}
          pagination={{ pageSize: 1000 }}
          dataSource={controlSheet ? [...controlSheet] : []} 
          columns={columns}
          loading={spinner}
          rowClassName={(record) => (record.is_email ? "odd" : "")}
        />
      </div>
      <Modal
        title={`Charge Payment for PT #${selectedRecord?.ship_header_no || ""}`}
        visible={isChargeModalVisible}
        onOk={handleChargeOk}
        onCancel={handleChargeCancel}
        okText="Submit Charge"
      >
        <Input
          type="number" // only allow numeric input
          placeholder="Enter charge amount"
          value={chargeAmount}
          onChange={(e) => setChargeAmount(e.target.value)}
          prefix="$"
          min={0}
          step="0.01"
        />
      </Modal>
    </div>
  );
};

export default CCOrdersCharge;
